/* eslint-disable import/no-unassigned-import */
import 'whatwg-fetch';
import {h, Component} from 'preact';
import AddAssociatedUsersSuccess from './add-associated-users-success';
import AddAssociatedUsersAlreadyExist from './add-associated-users-already-exist';
import AddAssociatedUsersFail from './add-associated-users-fail';
import AddAssociatedUsersHighlighEmails from './add-associated-users-highlight-emails';
import ErrorMessage from './error-message';

const generateKey = pre => {
	return `${pre}_${Date.now()}`;
};

function formatDate(date) {
	const d = new Date(date);
	let	month = String(d.getMonth() + 1);
	let	day = String(d.getDate());
	const	year = d.getFullYear();
	if (month.length < 2) {
		month = `0${month}`;
	}
	if (day.length < 2) {
		day = `0${day}`;
	}
	return [year, month, day].join('-');
}

const endDateInTenYears = formatDate(new Date(new Date().setFullYear(new Date().getFullYear() + 10)));
const initialState = {
	emailValue: '',
	endDateValue: endDateInTenYears,
	ignoreErrors: false,
	phase: 'initial',
	data: {
		associationExists: [],
		invalidEmails: [],
		invitationSent: []
	},
	identifiedEmails: [],
	errors: {
		failure: [],
		endDateError: undefined,
		hasInvalidEmails: false
	}
};
export default class AddAssociatedUsers extends Component {
	constructor(properties) {
		super(properties);

		this.state = initialState;
		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.handleEndDateChange = this.handleEndDateChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handlePhase = this.handlePhase.bind(this);
	}

	isAllowedToAddAssociatedUsers() {
		const institutionType = document.querySelector('#institutionType').textContent.trim().toUpperCase()
		return institutionType === 'INSTITUTION'
	}

	handleEmailChange(event) {
		this.setState({emailValue: event.target.value});
	}

	handleEndDateChange(event) {
		this.setState({endDateValue: event.target.value});
	}

	handleSubmit(event) {
		event.preventDefault();
		const emailValue = this.state.emailValue;
		const bpid = window.BPID;
		fetch(`/organizations/${bpid}/associated-users`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json'
			},
			credentials: 'include',
			body: JSON.stringify({emails: emailValue, endDate: this.state.endDateValue, ignoreErrors: this.state.ignoreErrors})
		}).then(response => {
			if (!response.ok) {
				// we will handle this later
				throw new Error(`Request rejected with status ${response.status}`);
			}
			return response.json();
		}).then(data => {
			this.setState({
				data: {
					associationExists: data.data.associationExists,
					invalidEmails: data.data.invalidEmails,
					invitationSent: data.data.invitationSent
				},
				identifiedEmails: data.identifiedEmails,
				errors: {
					failure: data.errors.failure,
					endDateError: data.errors.endDateError,
					hasInvalidEmails: data.errors.hasInvalidEmails
				},
				previousEmailValue: emailValue
			});

			// reseting the textarea since the input is correct and submitted
			if (data.data.associationExists.length > 0 || data.data.invitationSent.length > 0) {
				this.setState({
					emailValue: '',
					ignoreErrors: false
				});
			}

			this.handlePhase();
		}).catch(error => console.log('Error:', error));
	}

	handlePhase() {
		if (this.state.errors.hasInvalidEmails === true && this.state.identifiedEmails.length > 0) {
			if (this.state.ignoreErrors === false) {
				this.setState({phase: 'feedback'});
			} else {
				this.setState({phase: 'edit-feedback'});
			}
		} else {
			this.setState({phase: 'initial'});
		}
	}

	render(properties, state) {
		const hasNoEmails = state.errors.hasInvalidEmails === true && state.identifiedEmails.length === 0;
		const textAreaClass = (hasNoEmails) ? 'eds-c-form__input c-inputgroup__textarea--fullwidth c-inputgroup__textarea--errored' : 'eds-c-form__input c-inputgroup__textarea--fullwidth';
		const endDateClass = (state.errors.endDateError) ? 'eds-c-form__input c-inputgroup__input--errored' : 'eds-c-form__input c-inputgroup__input';

		return this.isAllowedToAddAssociatedUsers() ? (<form onSubmit={this.handleSubmit} class="u-margin-top-default c-card__interior-left">
			<h3 class="u-margin-top-default">New associations</h3>

			{state.phase !== 'feedback' &&
						<div class="eds-c-form__field">
							<label for="add-associated-users-email" class="eds-c-label">Email addresses to invite</label>
							<textarea id="add-associated-users-email" name="add-associated-users-email" class={textAreaClass}
								value={state.emailValue} onChange={this.handleEmailChange} required rows="3"> </textarea>
							{hasNoEmails && <ErrorMessage
								text="We cannot find any email addresses in the text. Let us know which email addresses to send invitations to." />}
						</div>}

			{state.phase !== 'initial' &&
						<AddAssociatedUsersHighlighEmails identifiedEmails={state.identifiedEmails}
							emailValue={state.previousEmailValue}
							showConfirmationMessage={state.phase === 'edit-feedback'} />}

			<div class="eds-c-form__field">
				<label for="add-associated-users-end-date" class="eds-c-label u-margin-top-default">End date</label>
				<input type="date" min={formatDate(new Date())} id="add-associated-users-end-date"
									 name="add-associated-users-end-date" class={endDateClass} value={state.endDateValue}
									 onChange={this.handleEndDateChange} />
				<p class="c-inputgroup__note">Today or later</p>
				{state.errors.endDateError && <ErrorMessage text="Choose an end date that is today or later." />}
			</div>

			{(state.phase !== 'feedback' ?
				<button type="submit" class="c-button u-margin-left-none u-margin-bottom-xlarge"
					data-track="click_associated_users_invite" data-track-category="Other access methods" data-track-action="Button Click" data-track-label="Invite user" data-track-context="Other access methods" data-track-prefer="click" data-testid="invite-users">Invite users</button> :
				<span>
					<button type="submit" onClick={() => this.setState({ignoreErrors: true})}
						class="c-button u-margin-left-none" data-track="click_associated_users_invite"  data-track-category="Other access methods" data-track-label="Invite user confirm" data-track-context="Other access methods" data-track-action="Button Click" data-track-prefer="click"
						>Yes, invite {state.identifiedEmails.length} user{state.identifiedEmails.length > 1 && 's'}</button>
					<button type="button" onClick={() => this.setState({ignoreErrors: false, phase: 'edit-feedback'})}
						class="c-button u-margin-left-none" data-track="click_associated_users_invite"  data-track-category="Other access methods" data-track-label="Invite user error edit" data-track-context="Other access methods" data-track-action="Button Click" data-track-prefer="click"
						>No, edit</button>
				</span>)}

			{(state.data.invitationSent.length > 0 ?
				<AddAssociatedUsersSuccess usersNum={state.data.invitationSent.length} key={generateKey('success')} /> : '')}
			{(state.data.associationExists.length > 0 ?
				<AddAssociatedUsersAlreadyExist usersNum={state.data.associationExists.length}
					feedback={state.data.associationExists} key={generateKey('exist')} /> : '')}
			{(state.data.invalidEmails.length > 0 || state.errors.failure.length > 0 ?
				<AddAssociatedUsersFail usersNum={state.data.invalidEmails.length} key={generateKey('fail')} /> : '')}
		</form>) : (<div />);
	}
}
